import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home'
import Account from '@/views/Account'
import CreateAccount from '@/views/CreateAccount'
import EventsList from '@/views/EventsList'
import MyEventsList from '@/views/MyEventsList'
import Event from '@/views/Event'
import JudgesList from '@/views/JudgesList'
import Judge from '@/views/Judge'
import Activate from '@/views/Activate'
import ResetPassword from '@/views/ResetPassword'
import store from '@/store'

Vue.use(Router)

function beforeEnter (to, from, next) {
	store.commit('clearEventsFilters')
	next()
}

export default new Router({
	mode: 'history',
	routes: [
		{
			path: '/',
			name: 'Home',
			component: Home,
			beforeEnter
		},
		{
			path: '/profile/',
			name: 'Account',
			component: Account,
			beforeEnter
		},
		{
			path: '/registration/',
			name: 'CreateAccount',
			component: CreateAccount,
			beforeEnter
		},
		{
			path: '/events/',
			name: 'EventsList',
			component: EventsList
		},
		{
			path: '/my-events/',
			name: 'MyEventsList',
			component: MyEventsList,
			beforeEnter
		},
		{
			path: '/events/:id',
			name: 'Event',
			component: Event
		},
		{
			path: '/judges/',
			name: 'JudgesList',
			component: JudgesList,
			beforeEnter
		},
		{
			path: '/judges/:id',
			name: 'Judge',
			component: Judge,
			beforeEnter
		},
		{
			path: '/activate/',
			name: 'Activate',
			component: Activate,
			beforeEnter
		},
		{
			path: '/reset-password/',
			name: 'ResetPassword',
			component: ResetPassword,
			beforeEnter
		}
	]
})



// WEBPACK FOOTER //
// ./src/router/index.js